import { Radio, Flex, Button } from 'antd'
import { CloseOutlined } from '@ant-design/icons'

export interface DeviceFilters {
  connectionStatus: 'all' | 'online' | 'offline'
  lastConnection: 'any' | 'today' | 'yesterday' | 'week' | 'month' | 'year'
}

interface DeviceFilterSidebarProps {
  filters: DeviceFilters
  onFilterChange: (filters: DeviceFilters) => void
  onClose: () => void
}

export const DEFAULT_FILTERS: DeviceFilters = {
  connectionStatus: 'all',
  lastConnection: 'any',
}

export default function DeviceFilterSidebar({
  filters,
  onFilterChange,
  onClose,
}: DeviceFilterSidebarProps) {
  return (
    <div
      style={{
        width: 250,
        minWidth: 250,
        background: '#fff',
        borderRight: '1px solid #e2e8f0',
        padding: '20px 16px',
        height: '100%',
        overflowY: 'auto',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
        <h3 style={{ fontSize: 15, fontWeight: 700, color: '#1e293b', margin: 0 }}>Filter list</h3>
        <Button type="text" size="small" icon={<CloseOutlined />} onClick={onClose} />
      </div>

      {/* Connection status */}
      <div style={{ marginBottom: 24 }}>
        <h4 style={{ fontSize: 13, fontWeight: 600, color: '#1e293b', margin: '0 0 12px' }}>
          Connection status
        </h4>
        <Radio.Group
          value={filters.connectionStatus}
          onChange={(e) => onFilterChange({ ...filters, connectionStatus: e.target.value })}
        >
          <Flex vertical gap={8}>
            <Radio value="all">All</Radio>
            <Radio value="online">Online</Radio>
            <Radio value="offline">Offline</Radio>
          </Flex>
        </Radio.Group>
      </div>

      {/* Last connection */}
      <div style={{ marginBottom: 24 }}>
        <h4 style={{ fontSize: 13, fontWeight: 600, color: '#1e293b', margin: '0 0 12px' }}>
          Last connection
        </h4>
        <Radio.Group
          value={filters.lastConnection}
          onChange={(e) => onFilterChange({ ...filters, lastConnection: e.target.value })}
        >
          <Flex vertical gap={8}>
            <Radio value="any">Any time</Radio>
            <Radio value="today">Today</Radio>
            <Radio value="yesterday">Yesterday</Radio>
            <Radio value="week">A week or less ago</Radio>
            <Radio value="month">A month or less ago</Radio>
            <Radio value="year">A year or less ago</Radio>
          </Flex>
        </Radio.Group>
      </div>

      {/* Missing status */}
      <div style={{ marginBottom: 24, opacity: 0.5, pointerEvents: 'none' }}>
        <h4 style={{ fontSize: 13, fontWeight: 600, color: '#1e293b', margin: '0 0 12px' }}>
          Missing status
        </h4>
        <Radio.Group value="all">
          <Flex vertical gap={8}>
            <Radio value="all">All</Radio>
            <Radio value="missing">Missing</Radio>
            <Radio value="not-missing">Not missing</Radio>
          </Flex>
        </Radio.Group>
      </div>

      {/* Labels */}
      <div style={{ opacity: 0.5 }}>
        <h4 style={{ fontSize: 13, fontWeight: 600, color: '#1e293b', margin: '0 0 12px' }}>
          Labels
        </h4>
        <p style={{ fontSize: 13, color: '#94a3b8', margin: 0 }}>No labels available</p>
      </div>
    </div>
  )
}
